
import React from 'react';
import { 
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Users } from "lucide-react";
import { UserRole } from "@/types/roles";
import { Customer } from '@/services/userService';

interface EditUserDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  selectedUser: Customer | null;
  newUserRole: UserRole;
  onRoleChange: (role: UserRole) => void;
  onSave: () => void;
}

export const EditUserDialog: React.FC<EditUserDialogProps> = ({
  open,
  onOpenChange,
  selectedUser,
  newUserRole,
  onRoleChange,
  onSave
}) => {
  if (!selectedUser) return null;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-gray-900 text-white border border-gray-700">
        <DialogHeader>
          <DialogTitle>Benutzer bearbeiten</DialogTitle>
          <DialogDescription className="text-gray-400">
            Rollen und Zugriffsrechte verwalten
          </DialogDescription>
        </DialogHeader>
        
        <div className="space-y-4 py-4">
          <div className="flex items-center gap-3 mb-4">
            <div className="h-12 w-12 rounded-full bg-blue-500/20 flex items-center justify-center">
              <Users className="h-6 w-6 text-blue-500" />
            </div>
            <div>
              <h3 className="font-medium">{selectedUser.name}</h3>
              <p className="text-sm text-gray-400">{selectedUser.email}</p>
            </div>
          </div>
          
          <div className="space-y-2">
            <Label htmlFor="role">Benutzerrolle</Label>
            <Select
              value={newUserRole}
              onValueChange={(value: UserRole) => onRoleChange(value)}
            >
              <SelectTrigger className="bg-gray-800 border-gray-700">
                <SelectValue placeholder="Wählen Sie eine Rolle" />
              </SelectTrigger>
              <SelectContent className="bg-gray-800 border-gray-700">
                <SelectItem value="user">Normaler Benutzer</SelectItem>
                <SelectItem value="admin">Administrator</SelectItem>
              </SelectContent>
            </Select>
            
            <p className="text-sm text-gray-400 mt-2">
              {newUserRole === 'admin' ? 
                'Administratoren haben vollen Zugriff auf das System und können alle Funktionen nutzen.' :
                'Normale Benutzer können ihre eigenen Dateien verwalten, aber keine Systemeinstellungen ändern.'}
            </p>
          </div>
        </div>
        
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Abbrechen
          </Button>
          <Button onClick={onSave}>
            Speichern
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
